import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { ToastProvider } from '@/components/ui';
import { AuthProvider } from '@/features/auth/AuthProvider';

import { ErrorBoundary } from './ErrorBoundary';
import { queryClient } from './queryClient';
import { AppRoutes } from './routes';
import { ThemeProvider } from './ThemeProvider';

export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <AuthProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </AuthProvider>
          </ToastProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
